module.exports = __webpack_public_path__ + "static/media/md-cloud-outline.76d2f12b.svg";